const showAdditionalService = false;
const routes = [
  {
    path: '/admin',
    component: () => import('@/layouts/WpLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/login',
      },
      {
        path: 'login',
        name: 'administrator-login',
        component: () => import('@/pages/Admin/AdminLogin.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_LOGIN_URL_FOR_ADMIN,
        },
      },
      {
        path: 'reset-password',
        name: 'administrator-reset-password',
        component: () => import('@/pages/Admin/AdminResetPassword.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_LOGIN_URL_FOR_ADMIN,
        },
      },
    ],
  },
  {
    path: '/admin',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/dashboard',
      },
      {
        path: 'dashboard',
        name: 'administrator-dashboard',
        component: () => import('@/pages/Admin/AdminDashboard.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Dashboard',
        },
      },
      {
        path: 'impersonate-landing',
        name: 'admin-impersonate-landing',
        component: () => import('@/pages/Admin/AdminImpersonateLanding.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Impersonate',
        },
      },
      {
        path: 'user-profile',
        name: 'administrator-user-profile',
        component: () => import('@/pages/Basic/UserProfile.vue'),
        meta: {
          rule: 'admin',
        },
      },
      // =============================================================================
      // Risk Profile Routes
      // =============================================================================
      {
        path: 'businesses/:businessOid/risk-profiles/create',
        name: 'administrator-risk-profile-create',
        component: () =>
          import('@/pages/Admin/RiskProfile/RiskProfileCreate.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Create Risk Profile',
          dark: true,
          redirect: 'leaveWithDialog',
          hideNav: true,
          appBarActions: () => [
            {
              name: 'UPDATE',
              label: 'Save as draft',
            },
            {
              name: 'CREATE',
              label: 'Publish',
            },
          ],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Businesses',
              'active-class': '',
              to: () => ({
                name: 'administrator-business-list',
              }),
            },
            {
              text: 'Risk Profiles',
              'active-class': '',
              to: (route) => {
                return {
                  name: 'administrator-risk-profile-list',
                  params: route.params,
                };
              },
            },
            {
              text: 'Create Risk Profile',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'businesses/:businessOid/risk-profiles/:riskProfileOid/update',
        name: 'administrator-risk-profile-update',
        component: () =>
          import('@/pages/Admin/RiskProfile/RiskProfileUpdate.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Update Risk Profile',
          dark: true,
          redirect: 'leaveWithDialog',
          hideNav: true,
          appBarActions: () => [
            {
              name: 'UPDATE',
              label: 'Save',
            },
            {
              name: 'CREATE',
              label: 'Publish',
            },
          ],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Businesses',
              'active-class': '',
              to: () => ({
                name: 'administrator-business-list',
              }),
            },
            {
              text: 'Risk Profiles',
              'active-class': '',
              to: (route) => {
                return {
                  name: 'administrator-risk-profile-list',
                  params: route.params,
                };
              },
            },
            {
              text: 'Update Risk Profile',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'businesses/:businessOid/risk-profiles/:riskProfileOid',
        name: 'administrator-risk-profile-read',
        component: () =>
          import('@/pages/Admin/RiskProfile/RiskProfileRead.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'View Risk Profile',
          dark: true,
          redirect: 'leave',
          hideNav: true,
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Businesses',
              'active-class': '',
              to: () => ({
                name: 'administrator-business-list',
              }),
            },
            {
              text: 'Risk Profiles',
              'active-class': '',
              to: (route) => {
                return {
                  name: 'administrator-risk-profile-list',
                  params: route.params,
                };
              },
            },
            {
              text: 'View Risk Profile',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'businesses/:businessOid/risk-profiles',
        name: 'administrator-risk-profile-list',
        component: () =>
          import('@/pages/Admin/RiskProfile/RiskProfileList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Risk Profile List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Businesses',
              'active-class': '',
              to: () => ({
                name: 'administrator-business-list',
              }),
            },
            {
              text: 'Risk Profiles',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Businesses Routes
      // =============================================================================
      {
        path: 'businesses/:businessOid/update',
        name: 'administrator-business-update',
        component: () => import('@/pages/Admin/Business/BusinessUpdate.vue'),
        meta: {
          rule: 'admin',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Businesses',
              'active-class': '',
              to: () => ({
                name: 'administrator-business-list',
              }),
            },
            {
              text: 'Business Details',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'businesses',
        name: 'administrator-business-list',
        component: () => import('@/pages/Admin/Business/BusinessList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Business List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Businesses',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Booking Routes
      // =============================================================================
      {
        path: 'bookings/:bookingOid',
        name: 'administrator-booking-read',
        component: () => import('@/pages/Admin/Booking/BookingRead.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'View Booking',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Booking History',
              'active-class': '',
              to: () => ({
                name: 'administrator-booking-list',
              }),
            },
            {
              text: 'View Quescreen',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'bookings',
        name: 'administrator-booking-list',
        component: () => import('@/pages/Admin/Booking/BookingList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Booking History',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'bookings/:bookingOid/report/:questionnaireAnswerOid',
        name: 'administrator-booking-candidate-report',
        component: () => import('@/pages/Admin/Booking/BookingReport.vue'),
        meta: {
          rule: 'admin',
          dark: true,
          hideNav: true,
        },
      },
      {
        path:
          'bookings/:bookingOid/health-check-summary/:questionnaireAnswerOid',
        name: 'administrator-booking-candidate-health-check-summary',
        component: () =>
          import('@/pages/Admin/Booking/HealthCheckSummary/Index.vue'),
        meta: {
          rule: 'admin',
          dark: true,
          hideNav: true,
        },
      },
      // =============================================================================
      // Question Group Routes
      // =============================================================================
      {
        path: 'question-groups',
        name: 'administrator-question-group-list',
        component: () =>
          import('@/pages/Admin/QuestionGroup/QuestionGroupList.vue'),
        meta: {
          rule: 'allowQuestionGroupCRUD',
          pageTitle: 'Question Groups',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Question Groups',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'question-groups/create',
        name: 'administrator-question-group-create',
        component: () =>
          import('@/pages/Admin/QuestionGroup/QuestionGroupCreate.vue'),
        meta: {
          rule: 'allowQuestionGroupCREATE',
          pageTitle: 'Create Question Group',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Question Groups',
              'active-class': '',
              to: () => ({
                name: 'administrator-question-group-list',
              }),
            },
            {
              text: 'Create Question Group',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'question-groups/:questionGroupOid/preview',
        name: 'administrator-question-group-preview',
        component: () =>
          import('@/pages/Admin/QuestionGroup/QuestionGroupPreview.vue'),
        meta: {
          rule: 'allowQuestionGroupREAD',
          pageTitle: 'Preview Question Group',
          hideNav: true,
          dark: true,
          redirect: 'leave',
        },
      },
      {
        path: 'question-groups/:questionGroupOid',
        name: 'administrator-question-group-update',
        component: () =>
          import('@/pages/Admin/QuestionGroup/QuestionGroupUpdate.vue'),
        meta: {
          rule: 'allowQuestionGroupREAD',
          pageTitle: 'Update Question Group',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Question Groups',
              'active-class': '',
              to: () => ({
                name: 'administrator-question-group-list',
              }),
            },
            {
              text: 'Update Question Group',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Risk Profile Template Routes
      // =============================================================================
      {
        path: 'risk-profile-templates/create',
        name: 'administrator-risk-profile-template-create',
        component: () =>
          import(
            '@/pages/Admin/RiskProfileTemplate/RiskProfileTemplateCreate.vue'
          ),
        meta: {
          rule: 'allowRiskProfileTemplateCreate',
          pageTitle: 'Create Risk Profile Template',
          dark: true,
          redirect: 'leaveWithDialog',
          hideNav: true,
          appBarActions: () => [],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Risk Profile Templates',
              'active-class': '',
              to: () => ({
                name: 'administrator-risk-profile-template-list',
              }),
            },
            {
              text: 'Create Risk Profile Template',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'risk-profile-templates/:rptOid',
        name: 'administrator-risk-profile-template-update',
        component: () =>
          import(
            '@/pages/Admin/RiskProfileTemplate/RiskProfileTemplateUpdate.vue'
          ),
        meta: {
          rule: 'allowRiskProfileTemplateRead',
          pageTitle: 'Update Risk Profile Template',
          dark: true,
          redirect: 'leaveWithDialog',
          hideNav: true,
          appBarActions: () => [
            {
              name: 'UPDATE',
              label: 'Save',
            },
          ],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Risk Profile Templates',
              'active-class': '',
              to: () => ({
                name: 'administrator-risk-profile-template-list',
              }),
            },
            {
              text: 'Update Risk Profile Template',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'risk-profile-templates',
        name: 'administrator-risk-profile-template-list',
        component: () =>
          import(
            '@/pages/Admin/RiskProfileTemplate/RiskProfileTemplateList.vue'
          ),
        meta: {
          rule: 'allowRiskProfileTemplateCRUD',
          pageTitle: 'Risk Profile Template List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Risk Profile Templates',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // User Routes
      // =============================================================================
      {
        path: 'users',
        name: 'administrator-users',
        component: () => import('@/pages/Admin/User/UserList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'User List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Users',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'users/:userId',
        name: 'administrator-user-read',
        component: () => import('@/pages/Admin/User/UserRead.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Update User',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text: 'Users',
              'active-class': '',
              to: () => ({
                name: 'administrator-users',
              }),
            },
            {
              text: 'Update User',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Service Candidate
      // =============================================================================
      {
        path: 'service-candidates/:serviceCandidateOid',
        name: 'admin-service-candidate-read',
        component: () =>
          import('@/pages/Admin/ServiceCandidate/ServiceCandidateRead.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'View Service Candidate',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'admin-dashboard',
              }),
            },
            {
              text: 'Service Candidates',
              'active-class': '',
              to: () => ({
                name: 'admin-service-candidate-list',
              }),
            },
            {
              text: 'View Service Candidate',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'service-candidates',
        name: 'admin-service-candidate-list',
        component: () =>
          import('@/pages/Admin/ServiceCandidate/ServiceCandidateList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Service Candidate List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'admin-dashboard',
              }),
            },
            {
              text: 'Service Candidates',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Business Credit Check
      // =============================================================================
      {
        path: 'business-credit-checks',
        name: 'admin-business-credit-check-list',
        component: () =>
          import('@/pages/Admin/Business/BusinessCreditCheckFullList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Business Credit Check List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'admin-dashboard',
              }),
            },
            {
              text: 'Business Credit Checks',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Service Payment
      // =============================================================================
      {
        path: 'service-payments/:servicePaymentOid',
        name: 'admin-service-payment-read',
        component: () =>
          import('@/pages/Admin/ServicePayment/ServicePaymentRead.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'View Service Payment',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'admin-dashboard',
              }),
            },
            {
              text: 'Service Payments',
              'active-class': '',
              to: () => ({
                name: 'admin-service-payment-list',
              }),
            },
            {
              text: 'View Service Payment',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'service-payments-report',
        name: 'admin-service-payment-report',
        component: () =>
          import('@/pages/Admin/ServicePayment/ServicePaymentReport.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Financial Report',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'admin-dashboard',
              }),
            },
            {
              text: 'Financial Report',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Service Order
      // =============================================================================
      {
        path: 'service-orders/create',
        name: 'admin-service-order-create',
        component: () =>
          import('@/pages/Admin/ServiceOrder/ServiceOrderCreate.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Purchase Quescreen',
          dark: true,
          hideNav: true,
          redirect: 'leaveWithDialog',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'admin-dashboard',
              }),
            },
            {
              text:
                'Purchase Quescreen' +
                (showAdditionalService ? ' or Additional Services' : ''),
              'active-class': '',
              to: () => ({
                name: 'admin-service-order-list',
              }),
            },
            {
              text: 'Purchase Quescreen',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'service-orders/list',
        name: 'admin-service-order-list',
        component: () =>
          import('@/pages/Admin/ServiceOrder/ServiceOrderList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text:
                'Purchase Quescreen' +
                (showAdditionalService ? ' or Additional Services' : ''),
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'service-orders/:serviceOrderOid',
        name: 'admin-service-order-read',
        component: () =>
          import('@/pages/Admin/ServiceOrder/ServiceOrderRead.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'View Order',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'administrator-dashboard',
              }),
            },
            {
              text:
                'Purchase Quescreen' +
                (showAdditionalService ? ' or Additional Services' : ''),
              'active-class': '',
              to: () => ({
                name: 'admin-service-order-list',
              }),
            },
            {
              text: 'View Order',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Booking Candidate Routes
      // =============================================================================
      {
        path: 'booking-candidates',
        name: 'admin-booking-candidate-list',
        component: () =>
          import('@/pages/Admin/BookingCandidate/BookingCandidateList.vue'),
        meta: {
          rule: 'admin',
          pageTitle: 'Quescreen Candidate History',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'admin-dashboard',
              }),
            },
            {
              text: 'Quescreen Candidate History',
              disabled: true,
            },
          ],
        },
      },
    ],
  },
];

export default routes;
